const PhoneIcon = () => {
  return (
    <svg
      className='social__svg'
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        className='social__path'
        d='M5 0C4.17157 0 3.5 0.671573 3.5 1.5V14.5C3.5 15.3284 4.17157 16 5 16H12C12.8284 16 13.5 15.3284 13.5 14.5V1.5C13.5 0.671573 12.8284 0 12 0H5ZM12 1.5H5L5 13H12V1.5ZM8.5 15.4375C9.00051 15.4375 9.40625 15.0318 9.40625 14.5312C9.40625 14.0307 9.00051 13.625 8.5 13.625C7.99949 13.625 7.59375 14.0307 7.59375 14.5312C7.59375 15.0318 7.99949 15.4375 8.5 15.4375Z'
        fill='white'
        fillOpacity='0.9'
      />
    </svg>
  );
};
export default PhoneIcon;
